import { OriCheckbox, OriNumberInput, OriSelect } from '@/src/components/Antd';
import ColorPicker from '@/src/components/ColorPicker/ColorPicker';
import React from 'react';
import {
  Item as ItemWrapper,
  //SectionContainer as Section,
  Row,
} from 'src/components/Layouts';
import Slider from 'src/components/Slider/MarginSlider';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EnumPosition } from 'src/types/common/common';
import { EBackgroundType } from 'src/types/common/module';
import css from './css.module.less';
const ModuleStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onChange, data, hideBkgConfig, isMobileOrTablet, hideBkgColor } =
    props;
  const {
    topPadding,
    bottomPadding,
    backgroundType,
    fullWidth,
    marginToTop,
    marginToBottom,
    marginToLeft,
    marginToRight,
    backgroundColor,
  } = data || {};

  const isBkgTypeIsNone = EBackgroundType.NONE === backgroundType;

  return (
    <React.Fragment>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper title={getI18n('general.topPadding')}>
                <OriNumberInput
                  size='large'
                  suffix={'px'}
                  min={0}
                  value={topPadding}
                  onChange={(topPadding) => {
                    if (onChange) {
                      onChange({ topPadding });
                    }
                  }}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper title={getI18n('general.bottomPadding')}>
                <OriNumberInput
                  min={0}
                  value={bottomPadding}
                  onChange={(bottomPadding) => {
                    if (onChange) {
                      onChange({ bottomPadding });
                    }
                  }}
                  size='large'
                  suffix={'px'}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      {!isMobileOrTablet && !hideBkgColor && (
        <ItemWrapper title={getI18n('general.backgroundType')}>
          <OriSelect
            size='large'
            value={backgroundType}
            onChange={(backgroundType) => {
              if (onChange) {
                onChange({ backgroundType });
              }
            }}>
            <OriSelect.Option value={EBackgroundType.COLOR}>
              {getI18n('general.colour')}
            </OriSelect.Option>
            <OriSelect.Option value={EBackgroundType.NONE}>
              {getI18n('general.status.none')}
            </OriSelect.Option>
          </OriSelect>
        </ItemWrapper>
      )}
      {!hideBkgConfig && (
        <React.Fragment>
          {!isBkgTypeIsNone && (
            <React.Fragment>
              <div className={css.checkboxContainer}>
                <OriCheckbox
                  checked={fullWidth}
                  onChange={(e) => {
                    const fullWidth = e.target.checked;
                    if (onChange) {
                      onChange({ fullWidth });
                    }
                  }}>
                  {getI18n('general.fullwidthbackground')}
                </OriCheckbox>
              </div>
              <Slider
                position={EnumPosition.top}
                title={getI18n('general.margintoTopEdge')}
                value={marginToTop}
                onChange={(marginToTop) => {
                  if (onChange) {
                    onChange({ marginToTop });
                  }
                }}
              />
              <Slider
                position={EnumPosition.bottom}
                title={getI18n('general.margintoBottomEdge')}
                value={marginToBottom}
                onChange={(marginToBottom) => {
                  if (onChange) {
                    onChange({ marginToBottom });
                  }
                }}
              />
              {!fullWidth && (
                <React.Fragment>
                  <Slider
                    position={EnumPosition.left}
                    title={getI18n('general.margintoLeftEdge')}
                    value={marginToLeft}
                    onChange={(marginToLeft) => {
                      if (onChange) {
                        onChange({ marginToLeft });
                      }
                    }}
                  />
                  <Slider
                    position={EnumPosition.right}
                    title={getI18n('general.margintoRightEdge')}
                    value={marginToRight}
                    onChange={(marginToRight) => {
                      if (onChange) {
                        onChange({ marginToRight });
                      }
                    }}
                  />
                </React.Fragment>
              )}
              {!isMobileOrTablet && (
                <ItemWrapper title={getI18n('general.backgroundColour')}>
                  <ColorPicker
                    multi
                    onChange={(color) => {
                      if (onChange) onChange({ backgroundColor: color });
                    }}
                    color={backgroundColor}
                  />
                </ItemWrapper>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default ModuleStyle;
